export default __webpack_public_path__ + "static/media/Visage of the Masquer of the Sands.765e98ba.jpg";